const affiliateForm = $('#AffiliateForm');
const {alertMessage} = require('../common/common');

affiliateForm.on('submit', function (event) {
    event.preventDefault();
    $('body').spinner().start();
    var form = $(this);
    var data = form.serialize();

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: data,
        success: function (response) {
            if (response.success) {
                $('.js-affiliation-summary').addClass('js-affiliation-summary-success');
                let url = window.location.href;    
                if (url.indexOf('?') > -1){
                url += '&affiliation=success'
                } else {
                url += '?affiliation=success'
                }
                window.location.href = url;
            } else {
                $('body').spinner().stop();
                $('.js-affiliation-summary').addClass('d-none');
                $('.js-affiliation-form').removeClass('d-none');
                alertMessage(response.message, 'cc-alert--danger');
                $('.js-affiliation-code-input-error').text(response.message);
                $('.js-affiliation-code-input-error').addClass('cc-message--visible');
            }
        },
        error: function (error) {
            $('body').spinner().stop();
            $('.js-affiliation-summary').addClass('d-none');
            $('.js-affiliation-form').removeClass('d-none');
            if (error.message) {
                alertMessage(error.message, 'cc-alert--danger');
                $('.js-affiliation-code-input-error').text(response.message);
                $('.js-affiliation-code-input-error').addClass('cc-message--visible');
            }
        }
    }).fail(function (error) {
        $('body').spinner().stop();
        $('.js-affiliation-summary').addClass('d-none');
        $('.js-affiliation-form').removeClass('d-none');
        if (error.message) {
            alertMessage(error.message, 'cc-alert--danger');
            $('.js-affiliation-code-input-error').text(response.message);
            $('.js-affiliation-code-input-error').addClass('cc-message--visible');
        }
    });
});